import { useState } from 'react';
import { supabase } from '../supabaseClient';

const ReportBugModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const { error } = await supabase
        .from('bug_reports')
        .insert({ email, description });

      if (error) throw error;
      
      alert('Bug report sent! Thank you.');
      onClose();
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to send the report.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white p-4 rounded max-w-md w-full">
        <h2 className="text-lg font-bold mb-4">Bug Report</h2>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <input
              type="email"
              placeholder="Your Email"
              required
              className="w-full p-2 border rounded"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          
          <div>
            <textarea
              placeholder="Bug Description"
              required
              rows="3"
              className="w-full p-2 border rounded"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
          </div>

          <div className="flex gap-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-red-500 text-white rounded"
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default function ReportBugButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
        <button onClick={() => setIsOpen(true)} className="fixed bottom-5 font-bold right-5 bg-red-500 text-white px-4 py-2 rounded-xl shadow-md hover:bg-red-700 border-gray-700 flex items-center gap-2">
            <svg className="w-6 h-6" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" fill="#000000"><g strokeWidth="0" /><g strokeLinecap="round" strokeLinejoin="round" /><g><ellipse cx="16" cy="17.5" rx="10" ry="10.5" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><path d="M11,8.4C11.3,5.9,13.4,4,16,4c2.6,0,4.7,1.9,5,4.4" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><line x1="2" y1="17" x2="6" y2="17" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><line x1="26" y1="17" x2="30" y2="17" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><line x1="5" y1="8" x2="8.1" y2="11" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><line x1="27.1" y1="8" x2="24" y2="11" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><path d="M16,7v7.1c0,4.6-2.4,8.9-6.3,11.5" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><path d="M16,7v7.1c0,4.6,2.4,8.9,6.3,11.5" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><line x1="5" y1="26" x2="7.7" y2="23.4" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /><line x1="27.1" y1="26" x2="24.3" y2="23.3" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" /></g></svg>
            Bug Report
        </button>
        
        <ReportBugModal isOpen={isOpen} onClose={() => setIsOpen(false)}/>
    </>
  );
}